import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TableColumnOrderState {
  [tableKey: string]: string[];
}

const tableColumnOrderSlice = createSlice({
  name: "tableColumnOrder",
  initialState: {} as TableColumnOrderState,
  reducers: {
    setTableColumnOrder(state, action: PayloadAction<{ tableKey: string; order: string[] }>) {
      state[action.payload.tableKey] = action.payload.order;
    },
  },
});

export const { setTableColumnOrder } = tableColumnOrderSlice.actions;
export const tableColumnOrderReducer = tableColumnOrderSlice.reducer;
export const selectTableColumnOrder =
  (tableKey: string) =>
  (state: any): string[] | undefined =>
    state.tableColumnOrder?.[tableKey];
